import { useIdentityQueueStore } from "@/stores/identityQueueStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import useModalActions from "@/composables/store/modal/useModalActions";
import useGlobalRouterActions from "@/composables/store/global/useGlobalRouterActions";

const { showSuccessModal } = useModalActions();
const { useLoadingStateAction } = useGlobalRouterActions();

export default function useBeforeEach() {
  const handleSuccessModal = (to, from, next) => {
    if (to.path.includes("error")) {
      return;
    }

    if (
      from.path.includes("/verification/code") &&
      !from.path.includes("/identity") && // handle back event
      !to.path.includes("verification") // handle back event
    ) {
      showSuccessModal({ progressLevel: "Verification" });
    } else if (
      from.path.includes("identity") &&
      !to.path.includes("identity") &&
      to.path.includes("/payment") &&
      !to.path.includes("/verification/code") // handle back event
    ) {
      showSuccessModal({ progressLevel: "Identity" });
    } else if (from.path.includes("/payment") && to.path.includes("/status")) {
      showSuccessModal({ progressLevel: "Payment" });
    }

    next();
  };

  const handleIdentityKycPathings = async (to, from, next) => {
    if (to.path.includes("error")) {
      next();
    }

    if (to.path.includes("identity") && !from.path.includes("/auth")) {
      const orderStore = useOrderFormStore();
      const {
        fetchIdentityDocuments,
        getNextIdentityRoute,
        removeFirstRouteAfterNavigation,
      } = useIdentityQueueStore();

      const anyDocumentsLeft = await fetchIdentityDocuments();

      if (anyDocumentsLeft) {
        next(getNextIdentityRoute);
        removeFirstRouteAfterNavigation();
      } else {
        next(`/payment/${orderStore.form.payment.value}`);
      }
    }
  };

  const resetLoadingButtonState = (to, from, next) => {
    useLoadingStateAction(false);
  };

  return {
    handleSuccessModal,
    handleIdentityKycPathings,
    resetLoadingButtonState,
  };
}
